import React from "react";
import "./FormHead.scss";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";

interface IHeadForm {
    tituloPrincipal?: string;
    descripcion?: string;
    tituloFormulario?: string;
    descripcionFormulario?: any;
}

// Componente para renderizar el contenido del encabezado de un formulario
const FormHead = (props: IHeadForm) => {


    return (
        <div className="m-form-head">
            {/* Seccion para titulos, subtitulos y textos principales. */}
            <div className="m-form-head__primary-content">
                {/* Tiulo principal */}
                {props.tituloPrincipal && (
                    <div className="m-form-head__titulo-principal">
                        <h2>{props.tituloPrincipal}</h2>
                    </div>
                )}
                {/* Descripcion principal */}
                {props.descripcion && (
                    <div className="m-form-head__descripcion">
                        <span>{props.descripcion}</span>
                    </div>
                )}
            </div>
            {/* Seccion para el mensaje del header */}
            <div className="m-form-head__message">
                {/* Titulo del mensaje del header */}
                {props.tituloFormulario && (
                    <div className="m-form-head__message-titulo">
                        <h3>{props.tituloFormulario}</h3>
                    </div>
                )}

                {/* Descripcion del mensaje para el header */}
                {props.descripcionFormulario && (
                    <div className="m-form-head__message-descripcion">
                        <span>
                            {/* renderiza los terminos para la autorizacion de datos. */}
                            {contentfulRenderOptions(
                                props.descripcionFormulario,
                            )}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FormHead;
